<template>
  <div class="my-3 py-2 container-fluid">
    <button
      v-if="lastSeason"
      @click="showCreateForm"
      class="mb-3 btn btn-sm btn-outline-success"
    >
      {{ $t("kids.createKid") }}
    </button>
    <div class="row">
      <transition name="slide-fade" class="my-4">
        <form-create-kid
          v-if="isCreateKidVisible"
          @close="hideEditForm"
          @formSubmitted="kidCreated"
        />
      </transition>
      <div class="col-12">
        <kid-list
          :kids="kids"
          :lastSeason="lastSeason"
          :isEditFormVisible="isEditFormVisible"
          @kid-updated="fetchKids"
          @hide-pagination="hidePagination"
          @show-pagination="showPagination"
          @hide-create-form="hideChild"
        />
      </div>
    </div>
    <span v-if="isPaginationVisible">
      <soft-pagination color="success" size="sm">
        <soft-pagination-item
          prev
          @click="prevPage"
          :disabled="currentPage === 1"
        />
        <div v-for="item in totalPages" :key="item">
          <soft-pagination-item
            v-if="item == currentPage"
            :label="currentPage"
            active
          />
          <soft-pagination-item
            v-if="item != currentPage"
            :label="item"
            @click="currPage(item)"
          />
        </div>
        <soft-pagination-item
          next
          @click="nextPage"
          :disabled="currentPage === totalPages"
        />
      </soft-pagination>
    </span>
  </div>
</template>

<script>
import axios from "axios";
import SoftPagination from "@/components/SoftPagination.vue";
import SoftPaginationItem from "@/components/SoftPaginationItem.vue";
import KidList from "./components/KidList";
import FormCreateKid from "@/components/FormCreateKid";

export default {
  name: "kids",
  components: {
    SoftPagination,
    SoftPaginationItem,
    KidList,
    FormCreateKid,
  },
  data() {
    return {
      kids: [],
      currentPage: 1,
      totalPages: 1,
      isPaginationVisible: true,
      isCreateKidVisible: false,
      isEditFormVisible: false,
      lastSeason: false,
    };
  },
  computed: {
    subcourseId() {
      return this.$route.params.id;
    },
    kidId() {
      return this.$route.params.kid;
    },
  },
  created() {
    this.checkIncommingRoute();
  },
  methods: {
    checkIncommingRoute() {
      if (this.$route.params.id) {
        this.fetchKidsSubcourse(this.subcourseId, this.currentPage);
      } else if (this.$route.params.kid) {
        this.fetchKid(this.kidId);
      } else {
        this.fetchKids(this.currentPage);
      }
    },
    async fetchKids(page = 1) {
      const response = await axios.get(`kids?page=${page}`);
      this.kids = response.data.kids;
      this.currentPage = response.data.meta.current_page;
      this.totalPages = response.data.meta.last_page;
      this.lastSeason = response.data.last_season;
    },
    async fetchKid(kidId) {
      const response = await axios.get("kid/" + kidId);
      this.kids = [response.data.kids];
    },
    async fetchKidsSubcourse(subcourseId, page = 1) {
      const response = await axios.get(`kids/subcourse?page=${page}`, {
        params: {
          subcourseId: subcourseId,
        },
      });
      this.kids = response.data.kids;
      this.currentPage = response.data.meta.current_page;
      this.totalPages = response.data.meta.last_page;
    },
    showCreateForm() {
      this.isCreateKidVisible = true;
      this.isEditFormVisible = false;
    },
    hideChild() {
      this.isCreateKidVisible = false;
      this.isEditFormVisible = true;
    },
    kidCreated() {
      this.isCreateKidVisible = false;
      this.fetchKids();
    },
    hideEditForm() {
      this.isCreateKidVisible = false;
      this.isEditFormVisible = false;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.checkIncommingRoute(this.currentPage);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.checkIncommingRoute(this.currentPage);
      }
    },
    currPage(page) {
      this.currentPage = page;
      this.checkIncommingRoute(page);
    },
    hidePagination() {
      this.isPaginationVisible = false;
    },
    showPagination() {
      this.isPaginationVisible = true;
    },
  },
};
</script>
